import React from "react";
import { Typography } from "antd";
import { useForm, ValidationError } from "@formspree/react";

import CustomInput from "../../../../shared/custom-input/custom-input";
import CustomButton from "../../../../shared/custom-button/custom-button";
import { NEWSLETTER_DATA } from "../../../../constants/content/shared/footer/newsletter";

import { BUTTON_VARIANTS } from "../../../../constants/styles";

import "./styles.scss";

const { Text } = Typography;

const Newsletter = () => {
  const [state, handleSubmit] = useForm("xvgrvbwe");

  if (state.succeeded) {
    return (
      <div className="Newsletter">
        <div className="Newsletter-headline">
          <Text className="Newsletter-headline-title">
            Thanks for subscribing!
          </Text>
          <Text className="Newsletter-headline-description">
            You'll receive our latest updates and insights.
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="Newsletter">
      <div className="Newsletter-headline">
        <Text className="Newsletter-headline-title">
          {NEWSLETTER_DATA.title}
        </Text>
        <Text className="Newsletter-headline-description">
          {NEWSLETTER_DATA.description}
        </Text>
      </div>
      <form onSubmit={handleSubmit} className="Newsletter-form">
        <CustomInput
          placeholder={NEWSLETTER_DATA.placeholder}
          name="email"
          id="email"
          type="email"
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <CustomButton
          btnVariant={BUTTON_VARIANTS.FORM}
          htmlType="submit"
          disabled={state.submitting}
        >
          {state.submitting ? "Subscribing..." : NEWSLETTER_DATA.buttonText}
        </CustomButton>
      </form>
    </div>
  );
};

export default Newsletter;
